import { useEffect, useState } from "react";

const useDebouncedValue = <T,>(value: T, debounceTime: number = 500) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const id = setTimeout(() => {
            setDebouncedValue(value);
        }, debounceTime);

        return () => {
            clearTimeout(id);
        }
    }, [debounceTime, value]);

    return debouncedValue;
};

export default useDebouncedValue;
